import { MOCK_ENABLED } from '../config'
import { STORAGE_KEY_MOCK, STORAGE_VALUE_MOCK } from '../constants/mock'
import { Mock, mock } from './mocker'

const isMockEnabled =
  MOCK_ENABLED &&
  window.localStorage.getItem(STORAGE_KEY_MOCK) === STORAGE_VALUE_MOCK

export function registerMocks(register: (m: Mock) => void) {
  if (isMockEnabled) {
    register(mock)

    displayMockEnabledMark()
  }
}

function displayMockEnabledMark() {
  const div = document.createElement('div')
  div.innerHTML = 'Mock Enabled'
  div.style.cssText =
    'font-size:10px;color:white;padding:2px 6px;background:rgba(238, 149, 0, .8);border-radius:0 0 2px 2px;position:fixed;top:0;left:50%;z-index:10000;'
  document.documentElement.appendChild(div)
}
